import React, { useState, useContext, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './ui/table';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from './ui/dialog';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from './ui/breadcrumb';
import { 
  ArrowLeft,
  RotateCcw, 
  Eye, 
  CheckCircle,
  AlertTriangle,
  X,
  Home,
  BarChart3,
  Activity,
  FileText,
  Clock,
  Zap,
  Timer,
  ChevronRight,
  ChevronLeft,
  Download
} from 'lucide-react';
import { format } from 'date-fns';
import { ChartExtractionRun, ChartExtractionChart,Chart } from '../src/Utils/chartExtractionMockData';
import { AppContext } from '../src/App';
import { apiClient } from '@/Utils/apiClient';
import { useAuth } from './AuthContext';
import { CircularLoader } from './ui/SkeletonLoader';
import { c } from 'node_modules/vite/dist/node/types.d-aGj9QkWt';
import { toast } from 'sonner';
import { Checkbox } from './ui/checkbox';
import { PaginationCustom } from './ui/pagination-custom';
import { buildQuery } from '@/Utils/helpers';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '@/routes/config';
interface chart{
  data:[],
  pagination:{
    limit: number;
    total: number;
    totalPages: number;
    page: number;
  }
}
interface chartLog{
  data:[],
  attempt:number
  processingTimeMs:number
}
export function ChartExtractionRunDetail() {
  const { sideBarItems, selectedExtractionRunData, setCurrentView,currentPageHarvestRun,setCurrentPageHarvestRuns,pagination,setPagination } = useContext(AppContext);
  const [selectedChart, setSelectedChart] = useState<Chart | null>(null);
  const navigate = useNavigate();
  const [showChartLogs, setShowChartLogs] = useState(false);
  const [selectedChartLog, setSelectedChartLog] = useState<chartLog>();
  const [currentPage, setCurrentPage] = useState(pagination.chartExtractionDetail||1);
  const [batchLog, setBatchLog] = useState([]);
  const [chartsData,setChartsData]=useState<chart>()
  // const [statusFilter, setStatusFilter] = useState('');
  const [selectedFailedChart, setSelectedFailedChart] = useState<string[]>([]);
  const [isAllFailedChart, setIsAllFailedChart] = useState({
    isFailed: false,
    open: false
  });
  const { token } = useAuth();
  const location = useLocation();
  const passedRunData = location.state?.runData;
  const runId = passedRunData?.run_id

  const [notification, setNotification] = useState<{type: 'success' | 'error', message: string} | null>(null);

  const chartReviewMenu = sideBarItems.find((item: any) => item.name === "Chart Extraction Details");

  const hasPermission = (permission: string) => {
    return chartReviewMenu?.userPermissions?.includes(permission);
  }
const itemsPerPage = 20;
  // const selectedRun = selectedExtractionRunData as ChartExtractionRun;
  
const fetchData=async()=>{
  try{
    const response=await apiClient(`extract/chart/logs/${runId}`,{
      method:'GET',
      token
    })
    const result=await response.json();
  
    // setSelectedRunDetail(result?.data)
    // setCurrentPage(prev=>({...prev,totalItems:result?.data?.processingLogs||0}))
    setBatchLog(result?.data||[])

  }catch(err){
    console.log(err)
    toast.error('Error fetching chart details');
  }
}

const handleLogDownload= async (runName: string) => {
  if (!runName) {
    toast.error("Cannot download log, run name is missing.");
    return;
  }

  try {

    const response = await apiClient(`extract/chart/logs/${runName}/download`, {
      method: 'GET',
      token
    });

    if (!response.ok) {
      const errText = await response.text(); // read raw
      try {
        const errJson = JSON.parse(errText);
        throw new Error(errJson.error || "Failed to download log");
      } catch {
        throw new Error("Failed to download log");
      }
    }

    // Success → read as blob
    const blob = await response.blob();

    const filename = `${runName}.txt`;

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);

  } catch (error: any) {
    console.error("Download error:", error);
    toast.error(error.message || "Could not download log.");
  }
};
const getChartDetails=async ()=>{
  try{
     const query={
    runId:runId,
    page:currentPage,
    limit:itemsPerPage
  }
  const queryParams=buildQuery(query,{
    page:"page",
    limit:"limit",
    runId:"runId"
  });
   const response=await apiClient(`extract/chart/processing/logs?${queryParams}`,{
    method:'GET',
    token
   })
   const result=await response.json();
  //  setSelectedRunDetail(result?.data);
  // setCurrentPage(prev=>({...prev,totalItems:result||0}))
  setChartsData(result)
  }
  catch(err){
    console.log(err)
    toast.error('Error fetching chart details');
  }
}
useEffect(()=>{
fetchData();
getChartDetails()
},[runId])
useEffect(()=>{
  getChartDetails()
},[currentPage])
const selectedRun=passedRunData;
  if (!selectedRun) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
     
      {/* <SkeletonLoader rows={5} center minHeight="300px" />
      //  */}
      <CircularLoader size={60} message="Fetching Charts Details" />
     
    </div>
      // <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      //   <div className="text-center">
      //     <h2 className="text-xl font-semibold text-gray-900 mb-2">Run Not Found</h2>
      //     <p className="text-gray-600 mb-4">The selected extraction run could not be found.</p>
      //     <Button onClick={() => setCurrentView('chart-extraction-runs')}>
      //       <ArrowLeft className="w-4 h-4 mr-2" />
      //       Back to Runs
      //     </Button>
      //   </div>
      // </div>
    );
  }

  const getRunTypeColor = (type: string) => {
    return type === 'Test' ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800';
  };

  const getChartTypeColor = (type: string) => {
    const colors = {
      'CSC - Section 28': 'bg-green-100 text-green-800',
      'DLS - Section 17': 'bg-blue-100 text-blue-800',
      'SN': 'bg-orange-100 text-orange-800',
      'Aide': 'bg-purple-100 text-purple-800'
    };
    return colors[type as keyof typeof colors] || 'bg-gray-100 text-gray-800';
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Success': return 'bg-green-100 text-green-800';
      case 'Failed': return 'bg-red-100 text-red-800';
      case 'In-Progress': return 'bg-amber-100 text-amber-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };
const getChartLogs=async (chart:Chart)=>{
  try{
  const response=await apiClient(`extract/chart/logs/${selectedExtractionRunData?.run_id}?chartId=${chart.chart_id}`,{
    method:'GET',
    token
    
  })
  const result=await response.json();
  if(!result?.success){
    throw new Error(result?.error)
  }
  setSelectedChartLog(result)
}
catch(err:any){
  console.log(err)
  if(err.status<500){
    toast.error(err.message)
  }
  else{
    toast.error('Error fetching chart logs');
}
}
}
  const formatTime = (ms: number) => {
    if (ms < 1000) return `${ms}ms`;
    if (ms < 60000) return `${(ms / 1000).toFixed(1)}s`;
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    return `${minutes}m ${seconds}s`;
  };

  const handleChartLogClick =async (chart: Chart,index:number) => {
    // await getChartLog();
    await getChartLogs(chart);
    const data={
      ...chart,
      index
    }
    setSelectedChart(data);

    setShowChartLogs(true);
  };

  const handleRerunFailed = (runId: string) => {
    // setNotification({
    //   type: 'success',
    //   message: `Rerun initiated for failed charts in ${runId}`
    // });
    // setTimeout(() => setNotification(null), 5000);
  };
// pagination
// const itemsPerPage = 10;
//   const totalPages = Math.ceil(currentPage.totalItems / itemsPerPage);
//   const startIndex = (currentPage - 1) * itemsPerPage;
//   const paginatedData = selectedRunDetail?.processingLogs.slice(startIndex, startIndex + itemsPerPage);

//   // Reset pagination when filters change
//   useEffect(() => {
//     if (searchTerm === "" && statusFilter === 'all') {
//       const totalPages = Math.ceil(currentPage.totalItems.length / itemsPerPage);
//       if (totalPages >= currentPageHarvestRun) {
//         setCurrentPage(prev=>({...prev,currentPage:currentPageHarvestRun}));
//       } else {
//         setCurrentPage(prev=>({...prev,currentPage:1}));
//       }
//     } else {
//       setCurrentPage(prev=>({...prev,currentPage:1}));
//     }
//   }, [searchTerm, statusFilter, totalPages]);
// pagination

// const totalPages = Math.ceil(currentPage.totalItems.length / itemsPerPage);
const totalItems=chartsData?.pagination?.total||0
const totalPages = chartsData?.pagination?.totalPages || Math.ceil(chartsData?.data?.length / itemsPerPage);

// Fix: Use currentPage.currentPage instead of currentPage
// const startIndex = (currentPage - 1) * itemsPerPage;
// const paginatedData = currentPage.totalItems?.slice(startIndex, startIndex + itemsPerPage);

// re run failded chart
 const handleChartToggle = (id: string) => {
    setSelectedFailedChart(prev =>
      prev.includes(id) ? prev.filter(chartId => chartId !== id) : [...prev, id]
    );
  };
const handleReRunFailedCharts= async(isAll:boolean)=>{
  try{
   let payload = {};

if (isAll) {
  payload = {
    rerunAll: true,
  };
} else {
  payload = {
    chartIds: selectedFailedChart,
    rerunAll: false,
  };
}

    const response=await apiClient(`chart-extraction/runs/${selectedExtractionRunData?.run_id}/rerun/charts`,{
      method:'PUT',
      token,
      body:payload
    })
    const result=await response.json();
    if(!result?.success){
      throw new Error(result?.error)
    }
    toast.success("Re-Run Success")

  }
  catch(err:any){
    if(err.status<500){
      toast.error(err.message)
    }
    else{
    toast.error("Something went wrong")
    }

  }
  finally{
    // setIsAllFailedChart(prev => ({ ...prev, isFailed: false }));
    setSelectedFailedChart([]);
  }
}
// Make sure this useEffect is also always called unconditionally
// useEffect(() => {
//   if (searchTerm === "" && statusFilter === 'all') {
//     // Fix: Use currentPage.totalItems instead of currentPage.totalItems.length
//     const calculatedTotalPages = Math.ceil(currentPage.totalItems / itemsPerPage);
    
//     // Fix: Define what currentPageHarvestRun should be, or remove this logic
//     // Assuming you want to keep the current page if it's valid
//     if (calculatedTotalPages >= currentPage.currentPage) {
//       // Keep current page if it's still valid
//       // No change needed
//     } else {
//       // Reset to page 1 if current page is beyond total pages
//       setCurrentPage(prev => ({ ...prev, currentPage: 1 }));
//     }
//   } else {
//     // Reset to page 1 when filters change
//     setCurrentPage(prev => ({ ...prev, currentPage: 1 }));
//   }
// }, [searchTerm, statusFilter, currentPage.totalItems]);
const onPageChange = (page: number) => {
    setCurrentPage(page);
    setPagination(prev=>({
      ...prev,
      chartExtractionDetail:page
    }))
  };
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Notification Banner */}
      {notification && (
        <div className={`fixed top-0 left-0 right-0 z-50 p-4 text-center text-white ${
          notification.type === 'success' ? 'bg-green-600' : 'bg-red-600'
        }`}>
          <div className="flex items-center justify-center gap-2">
            {notification.type === 'success' ? 
              <CheckCircle className="w-5 h-5" /> : 
              <AlertTriangle className="w-5 h-5" />
            }
            <span>{notification.message}</span>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setNotification(null)}
              className="text-white hover:bg-white/20"
            >
              <X className="w-4 h-4" />
            </Button>
          </div>
        </div>
      )}

      <div className=" mx-auto">
        {/* Breadcrumb */}
        <div className="mb-3">
          <Breadcrumb>
            <BreadcrumbList>
              {/* <BreadcrumbItem>
                <BreadcrumbLink 
                  href="#" 
                  className="flex items-center gap-1 text-gray-600 hover:text-gray-900"
                  onClick={() => setCurrentView('dashboard')}
                >
                  <Home className="w-3 h-3" />
                  Dashboard
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator /> */}
              <BreadcrumbItem>
                <BreadcrumbLink 
                  href="#"
                  className="text-gray-600 hover:text-gray-900"
                  onClick={() => setCurrentView('chart-extraction-runs')}
                >
                  Chart Extraction Runs
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage className="text-gray-900">Run Details - {selectedRun?.run_id}</BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        {/* Header */}
        <div className="flex items-start justify-between mb-6">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              onClick={() => {
                setCurrentView('chart-extraction-runs');
                navigate(ROUTES.chartExtractionList);
              }}
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900 !px-0"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Chart Extraction Runs
            </Button>
            <div className="border-l border-gray-300 pl-4">
              <h1 className="text-2xl font-bold text-gray-900 mb-1">
                Run Details - {selectedRun?.run_id}
              </h1>
              <p className="text-gray-600 text-base">
                Complete information for chart extraction run
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Badge 
              className={`text-sm px-3 py-1 rounded-md ${
                selectedRun?.run_status === 'Failed' ? 'bg-red-100 text-red-800 border border-red-200' :
                selectedRun?.run_status === 'Passed' ? 'bg-green-100 text-green-800 border border-green-200' :
                selectedRun?.run_status === 'In-Progress' ? 'bg-blue-100 text-blue-800 border border-blue-200' :
                'bg-gray-100 text-gray-800 border border-gray-200'
              }`}
            >
              {selectedRun?.run_status}
            </Badge>
            {/* {hasPermission("chart extract:create") && selectedRun.failed_charts > 0 && (
              <Button
                onClick={() =>  handleReRunFailedCharts(true)}
                className="flex items-center gap-2"
              >
                <RotateCcw className="w-4 h-4" />
                Rerun Failed Charts
              </Button>
            )} */}
          </div>
        </div>

        {/* Batch Summary */}
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-2">
            <BarChart3 className="w-5 h-5 text-blue-600" />
            <h2 className="text-xl font-semibold text-gray-900">Batch Summary</h2>
          </div>
          <p className="text-sm text-gray-600 mb-4">Chart extraction run overview and processing results</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-4">
            {/* Batch Info */}
            <div className="bg-white p-3 rounded-lg">
              <p className="text-xs uppercase tracking-wide text-gray-500 font-medium">BATCH NAME</p>
              <p className="font-mono text-lg font-semibold text-gray-900">{selectedRun?.batch_name}</p>
              <div className="flex gap-1 mt-2">
                <Badge className={`text-xs ${getRunTypeColor(selectedRun?.run_type)}`}>
                  {selectedRun?.run_type}
                </Badge>
                <Badge className={`text-xs ${getChartTypeColor(selectedRun?.chart_type)}`}>
                  {selectedRun?.chart_type}
                </Badge>
              </div>
            </div>

            {/* Run Date & Time */}
            <div className="bg-white p-3 rounded-lg">
              <p className="text-xs uppercase tracking-wide text-gray-500 font-medium">RUN DATE & TIME</p>
              <p className="text-lg font-semibold text-gray-900">{new Date(selectedRun?.start_datetime).toLocaleDateString('en-US')}</p>
              {selectedRun.run_status !== 'In-Progress' && (
                <p className="text-sm text-gray-600">
                  End:{selectedRun?.end_datetime && new Date(selectedRun?.end_datetime).toLocaleDateString('en-US',{ hour: '2-digit', minute: '2-digit', })}
                 {/* End: {(() => {
  if (selectedRun?.start_datetime) {
    return format(new Date(selectedRun.end_datetime), "dd/MM/yyyy HH:mm");
  }

  if (!selectedRun?.start_datetime) return "—";

  const start = new Date(selectedRun.start_datetime);
  if (isNaN(start.getTime())) return "Invalid date";

  const ms = selectedRun?.total_time_ms ?? 0;
  const endDate = new Date(start.getTime() + ms);

  return format(endDate, "dd/MM/yyyy HH:mm");
})()} */}

                </p>
              )}
            </div>

            {/* Total Charts */}
            <div className="bg-white p-3 rounded-lg">
              <p className="text-xs uppercase tracking-wide text-gray-500 font-medium">TOTAL CHARTS</p>
              {selectedRun.run_status === 'In-Progress' ? (
                <div className="flex flex-col">
                  <p className="text-lg font-semibold text-gray-900 animate-counting">{selectedRun?.total_charts
}</p>
                  <p className="text-xs text-amber-600 animate-pulse">still counting...</p>
                </div>
              ) : (
                <p className="text-lg font-semibold text-gray-900">{selectedRun?.total_charts}</p>
              )}
            </div>

            {/* Success Charts */}
            <div className="bg-white p-3 rounded-lg">
              <p className="text-xs uppercase tracking-wide text-green-600 font-medium">SUCCESSFUL CHARTS</p>
              <p className="text-lg font-semibold text-green-700">{selectedRun?.successful_charts||0}</p>
            </div>

            {/* Failed Charts */}
            <div className="bg-white p-3 rounded-lg">
              <p className="text-xs uppercase tracking-wide text-red-600 font-medium">FAILED CHARTS</p>
              <p className="text-lg font-semibold text-red-700">{selectedRun?.failed_charts}</p>
            </div>
            

            {/* Success Rate */}
            <div className="bg-white p-3 rounded-lg">
              <p className="text-xs uppercase tracking-wide text-blue-600 font-medium">SUCCESS RATE</p>
              <p className="text-lg font-semibold text-blue-700">
               {selectedRun?.total_charts
  ? ((selectedRun.successful_charts ?? 0) / selectedRun.total_charts * 100).toFixed(1) + '%'
  : '0%'}

              </p>
            </div>
          </div>
        </div>

        {/* Section Separator */}
        <div className="border-t border-gray-100 mb-6"></div>

        {/* Performance Metrics */}
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-2">
            <Activity className="w-5 h-5 text-green-600" />
            <h2 className="text-xl font-semibold text-gray-900">Performance Metrics</h2>
          </div>
          <p className="text-sm text-gray-600 mb-4">Timing and performance statistics</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-x-6 gap-y-4">
            {/* Start Time */}
            <div className="bg-white p-3 rounded-lg">
              <p className="text-xs uppercase tracking-wide text-green-600 font-medium flex items-center gap-1">
                <Clock className="w-3 h-3" />
                START TIME
              </p>
              <p className="text-lg font-semibold text-gray-900">{selectedRun?.start_datetime?new Date(selectedRun?.start_datetime).toLocaleTimeString('en-US'):''}</p>
            </div>

            {/* End Time */}
            {selectedRun.run_status !== 'In-Progress' && (
              <div className="bg-white p-3 rounded-lg">
                <p className="text-xs uppercase tracking-wide text-green-600 font-medium flex items-center gap-1">
                  <Clock className="w-3 h-3" />
                  END TIME
                </p>
                <p className="text-lg font-semibold text-gray-900">
                  {
                  selectedRun?.end_datetime && new Date(selectedRun?.end_datetime).toLocaleTimeString('en-US')
                  }
                  {/* {(() => {
  if (!selectedRun?.start_datetime) return "—";

  const start = new Date(selectedRun.start_datetime);
  if (isNaN(start.getTime())) {
    console.error("Invalid start_datetime:", selectedRun.start_datetime);
    return "Invalid date";
  }

  // Force total_time_ms to a number
  const ms = Number(selectedRun?.total_time_ms) || 0;

  const endDate = new Date(start.getTime() + ms);
  if (isNaN(endDate.getTime())) {
    console.error("Invalid endDate with:", {
      start: start.toString(),
      ms,
      raw: selectedRun?.total_time_ms,
    });
    return "Invalid end date";
  }

  return format(endDate, "HH:mm"); // show only time
})()

} */}

                </p>
              </div>
            )}

            {/* Avg Process Time */}
            <div className="bg-white p-3 rounded-lg">
              <p className="text-xs uppercase tracking-wide text-blue-600 font-medium flex items-center gap-1">
                <Zap className="w-3 h-3" />
                AVG PROCESS TIME
              </p>
              <p className="text-lg font-semibold text-gray-900">{(selectedRun?.average_time_ms / 1000).toFixed(2)}s</p>
            </div>

            {/* Total Process Time */}
            <div className="bg-white p-3 rounded-lg">
              <p className="text-xs uppercase tracking-wide text-blue-600 font-medium flex items-center gap-1">
                <Timer className="w-3 h-3" />
                TOTAL PROCESS TIME
              </p>
              <p className="text-lg font-semibold text-gray-900">{formatTime(selectedRun?.total_time_ms||0)}</p>
            </div>

            {/* Total Retries */}
            <div className="bg-white p-3 rounded-lg">
              <p className="text-xs uppercase tracking-wide text-orange-600 font-medium">TOTAL RETRIES</p>
              <p className="text-lg font-semibold text-orange-700">{selectedRun?.total_retries||0}</p>
            </div>
          </div>
        </div>

        {/* Section Separator */}
        <div className="border-t border-gray-100 mb-6"></div>

        {/* Error Summary */}
        {selectedRun?.failed_charts > 0 && (
          <div className="mb-6">
            <div className="flex items-center gap-2 mb-2">
              <AlertTriangle className="w-5 h-5 text-red-600" />
              <h2 className="text-xl font-semibold text-gray-900">Error Summary</h2>
            </div>
            <p className="text-sm text-gray-600 mb-4">Failed charts and error details</p>
            
            <div className="space-y-2">
              {chartsData?.data?.filter(chart => chart.status === 'Failed')
                .map(chart => (
                  <div key={chart.id} className="flex items-center  p-3 bg-red-50 rounded-lg border border-red-100 gap-2">
                    <span className="font-mono text-sm">{chart?.chart_id}</span>
                    <span className="text-sm text-red-700">{chart?.error_message}</span>
                  </div>
                ))
              }
            </div>
          </div>
        )}

        {/* Section Separator */}
        {selectedRun.failed_charts > 0 && <div className="border-t border-gray-100 mb-6"></div>}

        {/* Charts Table */}
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-2">
            <FileText className="w-5 h-5 text-gray-600" />
            <h2 className="text-xl font-semibold text-gray-900">Charts ({totalItems})</h2>
          </div>
          <div className='flex items-center justify-between mb-4'>
          <p className="text-sm text-gray-600 mb-4">Detailed chart processing information</p>
          {/* {hasPermission("chart extract:create") && (<Button className={`px-4 py-2 rounded 
  ${selectedFailedChart.length > 0 
    ? " text-white cursor-pointer opacity-100" 
    : " text-white opacity-50 cursor-not-allowed pointer-events-none"}`} onClick={()=>{handleReRunFailedCharts(false)}}>Re-run Charts</Button>)} */}
          </div>
          
          <div className="bg-white rounded-lg border border-gray-200">
            <Table>
              <TableHeader>
                <TableRow>    
                  <TableHead className="text-[14px] font-inter font-semibold leading-[100%] tracking-[-0.5%] whitespace-normal break-words uppercase text-[#758195]">Chart #</TableHead>
                  <TableHead className="text-[14px] font-inter font-semibold leading-[100%] tracking-[-0.5%] whitespace-normal break-words uppercase text-[#758195]">Chart ID</TableHead>
                  <TableHead className="text-[14px] font-inter font-semibold leading-[100%] tracking-[-0.5%] whitespace-normal break-words uppercase text-[#758195]">Visit Date</TableHead>
                  <TableHead className="text-[14px] font-inter font-semibold leading-[100%] tracking-[-0.5%] whitespace-normal break-words uppercase text-[#758195]">Goals</TableHead>
                  <TableHead className="text-center text-[14px] font-inter font-semibold leading-[100%] tracking-[-0.5%] whitespace-normal break-words uppercase text-[#758195]">Attempts</TableHead>
                  <TableHead className="text-center text-[14px] font-inter font-semibold leading-[100%] tracking-[-0.5%] whitespace-normal break-words uppercase text-[#758195]">Processing Time</TableHead>
                  <TableHead className="text-[14px] font-inter font-semibold leading-[100%] tracking-[-0.5%] whitespace-normal break-words uppercase text-[#758195]">Status</TableHead>
                  <TableHead className="text-[14px] font-inter font-semibold leading-[100%] tracking-[-0.5%] whitespace-normal break-words uppercase text-[#758195]">Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {chartsData?.data?.map((chart: Chart,index) => (
                  <TableRow key={chart?.id}>
                    <TableCell className="text-gray-900">  {(currentPage - 1) * itemsPerPage + index + 1}</TableCell>
                    <TableCell className="font-mono text-sm text-gray-900">{chart?.chart_id}</TableCell>
                    <TableCell>
                      <div className="text-sm text-gray-900">
                        {chart.visit_date && new Date(chart.visit_date)?.toLocaleDateString('en-US')}
                      </div>
                    </TableCell>
                    <TableCell className="text-gray-900">{chart.goal_units_count}</TableCell>
                    <TableCell className="text-center text-gray-900">{chart.attempt}</TableCell>
                    <TableCell className="text-center text-gray-900">{chart?.processing_time_ms ? formatTime(chart?.processing_time_ms):0}</TableCell>
                    <TableCell>
                      <Badge className={`text-xs ${getStatusColor(chart.status)}`}>
                        {chart?.status}
                      </Badge>
                    </TableCell>
                    <TableCell>
                      <div className="flex items-center gap-1">
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => handleChartLogClick(chart,(currentPage - 1) * itemsPerPage + index + 1)}
                          title="View Chart Log"
                        >
                          <Eye className="w-4 h-4" />
                        </Button>
                        {/* {chart.status === 'Failed' && (
                          // <Button
                          //   variant="ghost"
                          //   size="sm"
                          //   onClick={() => handleRerunFailed(chart.chartId)}
                          //   title="Re-run this Chart"
                          // >
                          //   <RotateCcw className="w-4 h-4" />
                          // </Button>
                           <div>
            {hasPermission("chart extract:create") && (
            <Checkbox
              checked={selectedFailedChart.includes(chart?.chart_id)}
              onCheckedChange={() => handleChartToggle(chart?.chart_id)}
              className="h-4 w-4 accent-black bg-white border border-gray-400 rounded-sm cursor-pointer"
              title="Re-run this Chart"
            />)}
            </div>
                        )} */}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
              
          </div>
          {/* {totalPages > 1 && (
                          <div className="flex items-center justify-between px-6 py-4 border-t  border-t">
                            <div className="text-sm text-gray-600">
                              Showing {startIndex + 1} to {Math.min(startIndex + itemsPerPage, currentPage.totalItems.length)} of {currentPage.totalItems.length} eCharts
                            </div>
          
                            <div className="flex items-center gap-2">
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => { setCurrentPage(prev=>({...prev,currentPage:Math.max(1, currentPage.currentPage - 1)})); setCurrentPageHarvestRuns(Math.max(1, currentPage.currentPage - 1)) }}
                                disabled={currentPage.currentPage === 1}
                              >
                                <ChevronLeft className="w-4 h-4" />
                                Previous
                              </Button>
          
                              <div className="flex items-center gap-1">
                                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                  const page = i + 1;
                                  return (
                                    <Button
                                      key={page}
                                      variant={currentPage.currentPage === page ? "default" : "outline"}
                                      size="sm"
                                      onClick={() => { setCurrentPage(prev=>({...prev,currentPage:page})); setCurrentPageHarvestRuns(page) }}
                                      className="w-8 h-8 p-0"
                                    >
                                      {page}
                                    </Button>
                                  );
                                })}
                                {totalPages > 5 && (
                                  <>
                                    <span className="text-gray-500">...</span>
                                    <Button
                                      variant={currentPage.currentPage === totalPages ? "default" : "outline"}
                                      size="sm"
                                      onClick={() => { setCurrentPage(prev=>({...prev,currentPage:totalPages})); setCurrentPageHarvestRuns(totalPages) }}
                                      className="w-8 h-8 p-0"
                                    >
                                      {totalPages}
                                    </Button>
                                  </>
                                )}
                              </div>
          
                              <Button
                                variant="outline"
                                size="sm"
                                onClick={() => { setCurrentPage(prev=>({...prev,currentPage:Math.min(totalPages, currentPage.currentPage + 1)})); setCurrentPageHarvestRuns(Math.min(totalPages, currentPage.currentPage + 1)) }}
                                disabled={currentPage.currentPage === totalPages}
                              >
                                Next
                                <ChevronRight className="w-4 h-4" />
                              </Button>
                            </div>
                          </div>
                        )} */}
                        {totalPages > 1 && (
  <div className="flex items-center justify-between px-6 py-4 border-t">
    <PaginationCustom
     currentPage={currentPage}
                        totalPages={totalPages}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        onPageChange={onPageChange}
                        onItemsPerPageChange={(newItemsPerPage) => {
                          onPageChange(1); // Reset page to 1
                        }}
      // currentPage={currentPage}      // your local state
      // totalPages={totalPages}                    // calculated total pages
      // totalItems={totalItems} // total items in your data
      // itemsPerPage={itemsPerPage}                // page size
      // onPageChange={(page) => {
      //   setCurrentPage(page);
      //   // setCurrentPageHarvestRuns(page); // keep your extra update
      // }}
      // onItemsPerPageChange={(size) => {
      //   // If you want itemsPerPage to be dynamic
      //   // setItemsPerPage(itemsPerPage);   //from dropdown if user select how many records needs to show then enable it
      //   setCurrentPage(1);
      //   // setCurrentPageHarvestRuns(1);
      // }}
      // pageSizeOptions={[10, 25, 50]}   // optional customization
      // showPageSizeSelector={false}     // hide dropdown since your inline didn’t use it
      // showItemCount={true}             // keep "Showing X to Y of Z"
    />
  </div>
)}
        </div>

        {/* Section Separator */}
        <div className="border-t border-gray-100 mb-6"></div>

        {/* Execution Log */}
        <div className="mb-6">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <FileText className="w-5 h-5 text-gray-600" />
              <h2 className="text-xl font-semibold text-gray-900">Execution Log</h2>
              </div>
              <Button
              variant="ghost"
              size="lg"
              onClick={() => {
                handleLogDownload(selectedExtractionRunData?.run_id || passedRunData?.run_id);
              }}
              title="Download Execution Log" // Changed title slightly
              className="p-2 rounded-lg text-gray-600 hover:bg-gray-100 hover:text-gray-900 transition-colors me-4"
             >
             <Download className="w-5 h-5" />
             {/* <span className="sr-only">Download Logs</span> */}
            </Button>
   
           </div>
          <p className="text-sm text-gray-600 mb-4">Recent processing logs and system messages</p>
          
          <div className="bg-gray-900 text-white p-3 rounded-lg font-mono text-sm max-h-64 overflow-y-auto">
            <div className="space-y-1">
              {batchLog?.map((log, index) => (
                <div key={index} className="text-gray-400">
              
                  {"["+log?.created_at+"]"+" "+log?.level+":"+" "+log?.message}
                 
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Chart Log Viewer */}
      <Dialog open={showChartLogs} onOpenChange={setShowChartLogs}>
        <DialogContent className="sm:max-w-4xl w-full max-h-[80vh]">
          <DialogHeader>
            <DialogTitle>Chart Log: {selectedChart?.chart_id}</DialogTitle>
            <DialogDescription>
              Processing logs for chart: {selectedChart?.index||0}
            </DialogDescription>
          </DialogHeader>
          
          {selectedChart && (
            <div className="space-y-4">
              <div className="grid grid-cols-3 gap-4 text-sm">
                <div>
                  <span className="text-gray-600">Status:</span>
                  <Badge className={`ml-2 text-xs ${getStatusColor(selectedChart.status)}`}>
                    {selectedChart.status}
                  </Badge>
                </div>
                <div>
                  <span className="text-gray-600">Processing Time:</span>
                  <span className="ml-2 font-medium">{formatTime(selectedChartLog?.processingTimeMs||0)}</span>
                </div>
                <div>
                  <span className="text-gray-600">Attempts:</span>
                  <span className="ml-2 font-medium">{selectedChartLog?.attempt}</span>
                </div>
              </div>

            <div className="bg-gray-900 text-green-400 p-4 rounded font-mono text-sm max-h-96 overflow-y-auto">
                {selectedChartLog?.data?.map((log, index) => (
                  <div key={index} className="mb-1">
                   
                   {"["+log?.created_at+"]"+" "+log?.level+":"+" "+log?.message}
                    </div>
                ))}
                {/* <div>
                  <p>{selectedChart?.status}</p>
                  <p className="text-red-400">{selectedChart?.error_message}</p>
                  </div> */}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>


    </div>
  );
}